import { render, staticRenderFns } from "./ActivityParameterCreateDetail.vue?vue&type=template&id=b826ec48"
import script from "./ActivityParameterCreateDetail.vue?vue&type=script&lang=js"
export * from "./ActivityParameterCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./ActivityParameterCreateDetail.vue?vue&type=style&index=0&id=b826ec48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports